import { h, type VNode } from 'vue';

import BaseTooltip from './BaseTooltip.vue';

const HINTED_TEXT_CLASS = 'cursor-help border-b border-dashed border-(--text-secondary)';

/**
 * Текст с пунктирным подчёркиванием и подсказкой: доступна с мышью,
 * клавиатурой и на сенсорном экране.
 */
export const renderHintedText = (text: string, content: string, className = HINTED_TEXT_CLASS): VNode =>
  h(BaseTooltip, { content, delay: 250 }, { default: () => h('span', { class: className }, text) });

/** Заголовок колонки таблицы с пояснением; высота строки — под касание. */
export const tooltipHeader = (content: string, text: string) => (): VNode =>
  renderHintedText(text, content, `inline-flex min-h-11 items-center ${HINTED_TEXT_CLASS}`);
